import React from 'react';

export const Masculino = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        fill="#4a89ba" // Cambia el color a azul
        strokeWidth="4" // Aumenta el grosor de las líneas
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M9.5 2a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.707L9.871 6.836a5 5 0 1 1-.707-.707L13.293 2zM6 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
          stroke="#4a89ba" // Color del contorno
          strokeWidth="0.8" // Grosor del contorno
        />
      </svg>
    );
  };
  
  export const Femenino = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        fill="#eeacb2" // Cambia el color a rosado oscuro
        strokeWidth="4" // Aumenta el grosor de las líneas
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 5a5 5 0 1 1 5.5 4.975V12h2a.5.5 0 0 1 0 1h-2v2.5a.5.5 0 0 1-1 0V13h-2a.5.5 0 0 1 0-1h2V9.975A5 5 0 0 1 3 5"
          stroke="#eeacb2" // Color del contorno
          strokeWidth="0.8" // Grosor del contorno
        />
      </svg>
    );
  };  